import React from "react";

function Header(props) {
  return (
    <div className="w-100 px-5 pt-3">
      <div className="p-1">
        <h1 className="text-left font-open-sans fw-b" id="publications">
          {props?.content}
        </h1>
      </div>
    </div>
  );
}

export default React.memo(Header);
